import { render, staticRenderFns } from "./ModalAtalhoTerritorioParaguai.vue?vue&type=template&id=0e31890d&lang=pug"
import script from "./ModalAtalhoTerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./ModalAtalhoTerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./ModalAtalhoTerritorioParaguai.vue?vue&type=style&index=0&id=0e31890d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports